import { createHelpers } from 'vuex-map-fields';

const { getSolicitudAltaField, updateSolicitudAltaField } = createHelpers({
  getterType: 'getSolicitudAltaField',
  mutationType: 'updateSolicitudAltaField',
});

export default {
  namespaced: true,
  state: {
    Personal: null,
    EstadoSolicitudMedica: 0,
    Fecha: null,
    FechaAltaMedica: null,
    FechaReingresoLaboral: null,
    CambiaFunciones: 0,
    AdecuacionTareas: null,
    ReduccionHoraria:null,
    LicenciaCargoPersonal_Id: 0,
    Personal_Id: 0,
    unidadeducativa_id: 0,
    nivelenseñanza_id: 0,
    UnidadAdministrativa_Id: 1,
    ListaLicenciaCargoPersonalSeleccionado: null,
    Observaciones: ''
  },
  mutations: {
    updateSolicitudAltaField,
  },
  getters: {
    getSolicitudAltaField,
  }
};



// WEBPACK FOOTER //
// ./src/store/formsolicitudalta.js